export enum ComponentStatus {
  Idle,
  Ok,
  Warning,
  Error
}
